<div
  class="layout-topbar bg-white dark:bg-surface-900  flex flex-row items-center justify-between w-full"
>
  <a routerLink="/app">
    <img
      [src]="isDarkTheme() ? 'assets/img/logo_wh.svg' : 'assets/img/logo_main.svg'"
      alt="logo "
      width="120"
      height="auto"
    />
  </a>
  <div class="flex flex-row items-center justify-between">
    <p-button
      [link]="true"
      icon="pi pi-plus"
      severity="secondary"
      size="small"
      styleClass="md:flex hidden"
      (click)="menu.toggle($event)"
    />
<app-notifications-popover />
    <app-theme-toggle-btn />
    <app-employee-avatar-fichaje-info [isMobile]="false" />
    <p-button
      (click)="sidebarVisible = true"
      size="small"
      [link]="true"
      severity="secondary"
      icon="pi pi-th-large"
      styleClass="lg:hidden"
    ></p-button>
  </div>
</div>
<p-tieredmenu #menu [model]="actions" [popup]="true" />


<p-drawer #drawer [(visible)]="sidebarVisible" position="right" styleClass="p-0">
  <div class="flex flex-col justify-between h-full">
    <app-dashboard-sidebar (onOptionSelected)="closeCallback($event)" />
    <app-employee-avatar-fichaje-info [isMobile]="true" (onDrawerlose)="closeCallback($event)" />
  </div>
</p-drawer>
